var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customDivWaiting"> <div class="container"> <div style="height:20px"></div> <div class="row"> <div class="col-md-6"> <h1 class="text-center"> '+
((__t=( model.EventName ))==null?'':__t)+
' </h1> <p class="text-center" style="text-align: justify; white-space:pre-wrap"> '+
((__t=( model.Description ))==null?'':__t)+
' </p> <p> <i class="fas fa-map-marker-alt"></i> '+
((__t=( model.Address ))==null?'':__t)+
' </p> <p> <i class="far fa-clock"></i> '+
((__t=( model.strStartDate ))==null?'':__t)+
'-'+
((__t=( model.strEndDate ))==null?'':__t)+
' </p> </div> <div class="col-md-6"> <div class="" style="text-align: center"> <img style="height:50%; width:50%" alt="" src="'+
((__t=( model.WebpageImageUrl ))==null?'':__t)+
'"> </div> </div> </div> <div style="height:20px"></div> <div class="row"> <div class="col-md-6"> <div class="" style="text-align: center"> <img style="margin-bottom:20px;min-width:150px;min-height:150px;max-width:150px;max-height:150px" alt="" src="'+
((__t=( model.QRCodeImageUrl ))==null?'':__t)+
'"> </div> </div> <div class="col-md-6"> <button type="button" class="btn btn-secondary btn-block" id="searchEventListItemDetails_btnBack">'+
((__t=( resources['X100274'] ))==null?'':__t)+
'</button> <button type="button" class="btn btn-secondary btn-block" id="searchEventListItemDetails_webpageEvent">'+
((__t=( resources['X100092'] ))==null?'':__t)+
'</button> <button type="button" class="btn btn-secondary btn-block" id="searchEventListItemDetails_webpageEventPreview">'+
((__t=( resources['X100276'] ))==null?'':__t)+
'</button> <button type="button" class="btn btn-secondary btn-block" id="searchEventListItemDetails_webpageEventSchemaScreen">'+
((__t=( resources['X100506'] ))==null?'':__t)+
'</button> <button type="button" class="btn btn-secondary btn-block" id="searchEventListItemDetails_webpageEventInfoScreen">'+
((__t=( resources['X100507'] ))==null?'':__t)+
'</button> <button type="button" class="btn btn-secondary btn-block" id="searchEventListItemDetails_webpageEventPoster">'+
((__t=( resources['X100550'] ))==null?'':__t)+
'</button> </div> </div> <div style="height:20px"></div> </div> </div> <div id="searchEventListItem"></div>';
}
return __p;
};
